import request from '@/utils/request'

const urlPrefix = '/system'

export function getSystemStatus () {
  return request.get(`${urlPrefix}/status`)
}
